import React, { useState, useEffect, Fragment } from "react";
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";

import HQQADeploy from "./HQ/QA/Deploy/index";

import "@app/pages/Internal/internal.css";

const InternalRoute = (props) => {
    const urlBase = `${process.env.REACT_APP_BASE_URL}/internal`;
    return (
        <Fragment>
            <Router exact path={urlBase} basename={urlBase}>
                <Switch>
                    <Route path="/hq/qa/deploy" component={HQQADeploy} />
                </Switch>
            </Router>
        </Fragment>
    );
};

export { InternalRoute as default };
